export const MONTHLY_PAYMENT_TOO_LOW_MESSAGE =
  'Please enter a higher monthly payment.';
